module.exports = __webpack_public_path__ + "static/media/class of stduents.09683249.svg";